import { render, staticRenderFns } from "./resourceUpload.vue?vue&type=template&id=62df6210&scoped=true"
import script from "./resourceUpload.vue?vue&type=script&lang=js"
export * from "./resourceUpload.vue?vue&type=script&lang=js"
import style0 from "./resourceUpload.vue?vue&type=style&index=0&id=62df6210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62df6210",
  null
  
)

export default component.exports